import React from 'react';

function Pause() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M2 23.926h6.667V.074H2v23.852zM15.333.074v23.852H22V.074h-6.667z" />
    </svg>
  );
  /* eslint-enable */
}

export default Pause;



// WEBPACK FOOTER //
// ./src/common/icons/Pause.js